import React from 'react'
import Table from './../../../common/table';

const SellerTable = (props) => {

    const { data, columns, ...rest } = props;

    return (
    <>

    <Table
      columns={columns}
      data={data}
      {...rest}
     />

    </>
  )
}

export default SellerTable